
const {LANGUAGE} = require("./constant")
// 常用常数配置
const ARGUMENTS = {
    // 支持语言
    language:(opt)=> [
        '[language]',
        `[${LANGUAGE.join('/')}] default(${LANGUAGE[0]})`,
        (language) => {
            if (!LANGUAGE.includes(language)) {
                log.en('error', `command-argument value '${language}' is invalid for argument 'language' , please choice right language in [${LANGUAGE.join(',')}]`)
                throw new  opt.commander.InvalidArgumentError();
            }
            return language
        }
        ,
        LANGUAGE[0]
    ]
}

module.exports = {
    ARGUMENTS
}